
function get(par) {
    const local_url = decodeURI(document.location.href)
    const getstr = local_url.substr(local_url.indexOf('?') + 1)
    const get = getstr.split('&')
    for (var i in get) {
        if (get[i].indexOf(par + '=') >= 0) {
            return get[i].replace(par + '=', '')
        }
    }
    return false
}
const id = get('id')
const subId = get('subId')
const idx = get('idx')
const nav = $("#member-nav").text()

// 背景图
const bg = get('bg')
let bgList = ''
bgList += `<img class="bg-img" src= ${bg} />`
$('#bg-box').append(bgList)

// $(document).ready( () => {
//     const url = decodeURIComponent(window.location.href);
//     $(".member-list").children('#subNav').each(function () {
//         if (returnUrl($(this).attr("href")) == returnUrl(url)) {
//             $(this).addClass("current");
//         }
//     });

//     //以下为截取url的方法 
//     function returnUrl(href) {
//         var number = href.lastIndexOf("/");
//         return href.substring(number + 1);
//     }
// })
if(subId) {
    $.get(`/api/admin/official/exc/informationPageList/${id}/${subId}?current=1&size=12`, function (data) {
        const memberList = data.data.records
        var contentList = ''
        if(data.data.total === 0) {
            const div = `<div class="no-text">
                            <img src="/static/images/vindicate-icon.png">
                            <p>暂无内容</p>
                        </div>`
            $(".content-list-box").html(div)
        } else {
            $.each(memberList, function (i) {
                if (memberList[i].subtitle === null) {
                    memberList[i].subtitle = ""
                }
                if (memberList[i].coverUrl === "") {
                    memberList[i].coverUrl = "/static/images/bg.png"
                }
                if(memberList[i].linkType === 0 || memberList[i].linkType === null) {
                    contentList += 
                    "<a class= " + 'content-list ' + "href=" + 'memberDetail.html?idx='+ idx + '&id=' + memberList[i].id + '&nav=' + encodeURI(nav)+ '&bg=' + bg + ">" +
                        "<img class= " + 'content-img ' + "src=" + memberList[i].coverUrl + ">" + "</img>" +
                        '<div class="detail-title">' + memberList[i].title + '</div>' +
                        '<div class="content-detail">' +
                            '<div class="detail-content">' + memberList[i].subtitle + '</div>' +
                            '<div class="detail-time ">' + memberList[i].publicTime + '</div>' +
                        '</div>' +
                    "</a>"
                    $(".content-list-box").html(contentList)
                } else {
                    contentList += 
                    "<a class= " + 'content-list ' + "href=" + memberList[i].linkUrl +' target=_blank' + ">" +
                        "<img class= " + 'content-img ' + "src=" + memberList[i].coverUrl + ">" + "</img>" +
                        '<div class="detail-title">' + memberList[i].title + '</div>' +
                        '<div class="content-detail">' +
                            '<div class="detail-content">' + memberList[i].subtitle + '</div>' +
                            '<div class="detail-time ">' + memberList[i].publicTime + '</div>' +
                        '</div>' +
                    "</a>"
                    $(".content-list-box").html(contentList)
                }
            })
        }
        // const more = `<div class="more">加载更多</div>`
        // $('.content-box').append(more)
        if(data.data.size >= data.data.total) {
            $(".more").hide()
        } else {
            $(".more").show()
        }
    })
    
    // 加载更多
    $(document).ready(function () {
        let num = 12
        $(".more").click(function () {
            num += 12
            $.get(`/api/admin/official/exc/informationPageList/${id}/${subId}?current=1&size=` + num, function (data) {
                const memberList = data.data.records
                var contentList = ''
                $.each(memberList, function (i, item) {
                    if (memberList[i].subtitle === null) {
                        memberList[i].subtitle = ""
                    }
                    if (memberList[i].coverUrl === "") {
                        memberList[i].coverUrl = "/static/images/bg.png"
                    } 
                    if(memberList[i].linkType === 0 || memberList[i].linkType === null) {
                        contentList += 
                        "<a class= " + 'content-list ' + "href=" + 'memberDetail.html?idx='+ idx + '&id=' + memberList[i].id + '&nav=' + encodeURI(nav)+ '&bg=' + bg + ">" +
                            "<img class= " + 'content-img ' + "src=" + memberList[i].coverUrl + ">" + "</img>" +
                            '<div class="detail-title">' + memberList[i].title + '</div>' +
                            '<div class="content-detail">' +
                                '<div class="detail-content">' + memberList[i].subtitle + '</div>' +
                                '<div class="detail-time ">' + memberList[i].publicTime + '</div>' +
                            '</div>' +
                        "</a>"
                        $(".content-list-box").html(contentList)
                    } else {
                        contentList += 
                        "<a class= " + 'content-list ' + "href=" + memberList[i].linkUrl +' target=_blank' + ">" +
                            "<img class= " + 'content-img ' + "src=" + memberList[i].coverUrl + ">" + "</img>" +
                            '<div class="detail-title">' + memberList[i].title + '</div>' +
                            '<div class="content-detail">' +
                                '<div class="detail-content">' + memberList[i].subtitle + '</div>' +
                                '<div class="detail-time ">' + memberList[i].publicTime + '</div>' +
                            '</div>' +
                        "</a>"
                        $(".content-list-box").html(contentList)
                    }
                })
                if(data.data.size >= data.data.total) {
                    $(".more").hide()
                }
            })
        })
    })
    
}
